import sharedLabel from '../../../translation'

export default {
    ...sharedLabel
}